<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start" *ngIf="!forceUpdate">
      <ion-button (click)="goBack()">
          <ion-icon color="dark" class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'APP_UPDATE.title' | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="content-div">
    <div>
      <ion-img class="img center" src="./assets/wedding/img/update/app-update.webp"></ion-img>
    </div>
    <ng-container *ngIf="currentVersion">
      <ng-container *ngIf="checkNewVersion else latestVersionBlock">
        <div class="ion-margin ion-padding">
          <div class="ion-text-center">
            <ion-text class="font-20 font-med">{{ 'APP_UPDATE.msg.available' | translate }}</ion-text>
          </div>
          <div class="font-14 ion-text-center ion-padding" *ngIf="currentVersion && newVersion">
            <ion-text *ngIf="forceUpdate" [innerHtml]="'APP_UPDATE.msg.intro.force' | translate"></ion-text>
            <ion-text *ngIf="!forceUpdate" [innerHtml]="'APP_UPDATE.msg.intro.new' | translate"></ion-text>
          </div>
          <div class="ion-margin ion-text-center" *ngIf="currentVersion">
            <ion-text class="font-14">{{ 'APP_UPDATE.msg.current_version' | translate }}</ion-text>
            <div>
              <ion-text class="font-bold">{{ currentVersion }}</ion-text>
            </div>
          </div>
        </div>
        <div class="ion-margin ion-text-center" *ngIf="minVersion">
          <ion-text class="font-14">{{ 'APP_UPDATE.msg.new_version' | translate }}</ion-text>
          <div>
            <ion-text class="font-bold">{{ newVersionText }}</ion-text>
          </div>
        </div>
      </ng-container>
      <ng-template #latestVersionBlock>
        <div class="ion-margin ion-padding">
          <div class="ion-text-center">
            <ion-text class="font-20 font-med">{{ 'APP_UPDATE.msg.latest' | translate }}</ion-text>
          </div>
          <div class="font-14 ion-text-center ion-padding" *ngIf="currentVersion && newVersion">
            <ion-text [innerHtml]="'APP_UPDATE.msg.intro.latest' | translate"></ion-text>
          </div>
          <div class="ion-margin ion-text-center" *ngIf="currentVersion">
            <ion-text class="font-14">{{ 'APP_UPDATE.msg.current_version' | translate }}</ion-text>
            <div>
              <ion-text class="font-bold">{{ currentVersion }}</ion-text>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </div>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <div class="content-div">
      <ng-container *ngIf="checkNewVersion else mainPage">
        <div class="ion-margin ion-text-center" *ngIf="webPlatform">
          <ng-container *ngIf="timestamp">
            <div class="ion-margin-bottom" *ngIf="webPlatform && btnCount >= 1">
              <ion-text class="ion-margin-bottom" [ngClass]="btnCount >= 2 ? (webPlatform === 'mobile' ? 'font-18/' : 'font-24') : 'font-12'" [innerHTML]="'APP_UPDATE.msg.web.' + webPlatform + (webPlatform === 'mac' ? ('.' + getBrowserType) : '') | translate"></ion-text>
            </div>
            <div class="ion-margin-bottom" *ngIf="storageCount >= 2">
              <ion-text class="font-12" [innerHTML]="'APP_UPDATE.msg.retry' | translate"></ion-text>
            </div>
          </ng-container>
          <ng-container *ngIf="btnCount < 2">
            <ion-button expand="block" (click)="goUpdate()">{{ 'APP_UPDATE.btn.update' | translate }}</ion-button>
          </ng-container>
        </div>
        
        <div class="ion-margin ion-text-center" *ngIf="!forceUpdate">
          <ion-text class="font-underline font-10" (click)="goBack()">{{ 'BTN.skip' | translate }}</ion-text>
        </div>
      </ng-container>
      <ng-template #mainPage>
        <ion-button class="ion-margin" expand="block" (click)="goMainPage()">{{ 'MENU.home' | translate }}</ion-button>
      </ng-template>
    </div>
  </ion-toolbar>
</ion-footer>